import clsx from 'clsx'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
}

export function Price({ price, compareAtPrice, className = 'flex' }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')

  const formatPrice = (value: string) => {
    return value.replace(/\.0{1,2}$/, '')
  }

  return (
    <p className={clsx('flex-col', className)}>
      {!isOnSale ? null : (
        <span className="line-through paragraph-sm text-brand-black">
          ${formatPrice(compareAtPrice || '')}
        </span>
      )}

      <span className={clsx('paragraph-md md:paragraph-lg', isOnSale ? 'text-brand-sale' : 'text-brand-black')}>
        ${formatPrice(price)}
      </span>
    </p>
  )
}
